import { render, staticRenderFns } from "./ConvenioPrestacaoContasMensal.vue?vue&type=template&id=11aba8e6&"
import script from "./ConvenioPrestacaoContasMensal.vue?vue&type=script&lang=js&"
export * from "./ConvenioPrestacaoContasMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports